export const createPaths = {
  upload: "upload",
  clean: "clean",
  filter: "filter",
  augment: "add-columns",
  grouped_aggregates: "grouped-aggregates",
  time_series: "time-series",
  join: "join",
  stack: "stack",
  subset: "split",
  template: "macro",
  flatten: "flatten",
};

export const createOptions = [
  {
    title: "Use a Macro",
    subtitle: "One-Click Creation",
    text: "Use a pre-existing macro to create a new Data File",
    link: createPaths.template,
    singleFile: false,
    active: true,
  },
  {
    title: "Clean/Prepare",
    subtitle: "Clean/Prepare Existing Data to Create a New File",
    text: "Missing Value Treatment, Outlier Treatment, Type-casts, etc.",
    link: createPaths.clean,
    singleFile: true,
    active: true,
  },
  {
    title: "Augment (Add New Columns)",
    subtitle: "Add New Columns to Existing Data and Create a New File",
    text:
      "Arithmetic Transforms, Running and Time-Window Stats, Shifts/Leads/Lags, Geo-Coding, etc.",
    link: createPaths.augment,
    singleFile: true,
    active: true,
  },
  {
    title: "Convert to Time-Series",
    subtitle:
      "Generate Time-Series from existing data using grouping variables and time-resolution.",
    text: "Mean, First, Last, Sum, Count, Max, Min, etc.",
    link: createPaths.time_series,
    singleFile: true,
    active: true,
  },
  {
    title: "Rollup Data by Group",
    subtitle: "Rollup Data using Grouping Variables to Create a New File",
    text:
      "Mean, Median, Sum, Differences, Unique-Counts, Concentration Indices, First, Last, Contents, etc.",
    link: createPaths.grouped_aggregates,
    singleFile: true,
    active: true,
  },
  {
    title: "Flatten Data",
    subtitle:
      "Create multiple columns using a single Cat Column - group rows into a single unit too.",
    text: "Aggregate Attributes, Unique Attributes, etc.",
    link: createPaths.flatten,
    singleFile: true,
    active: true,
  },
  {
    title: "Filter Data",
    subtitle: "Extract a Subset of Data into a separate File",
    text: "Apply Filters on Data, and make filtered data-sets.",
    link: createPaths.filter,
    singleFile: true,
    active: true,
  },
  {
    title: "Stack Data to Single File",
    subtitle: "Stack Files on Top of Each Other to Create a New File",
    text:
      "Files with same columns, but corresponding to different groups, e.g., Year, Gender",
    link: createPaths.stack,
    singleFile: false,
    active: true,
  },
  {
    title: "Join Data (DB-Style)",
    subtitle: "Join Data (DB-Style) to Create a New File.",
    text:
      "Indexed joins (including lookup-style). Inner and Outer Joins. And multiple files.",
    link: createPaths.join,
    singleFile: false,
    active: false,
  },

  // {
  //   title: "Split Data to Multiple Files",
  //   subtitle: "Divide Data into Multiple Files",
  //   text: "Use sub-setting criteria to easily split Data into multiple parts.",
  //   link: paths.subset,
  //   icon: faSitemap
  // },
];

export default createOptions;
